import { cn } from '~/lib/cn';

export const OVERLAY_CLASS = {
  show: cn('animate-[dialogOverlay_300ms_ease-out_forwards]'),
  hide: cn('animate-[dialogOverlay_300ms_ease-in_reverse_forwards]'),
} as const;

export const PANEL_CLASS = {
  show: cn('translate-x-0'),
  disable: cn('!pointer-events-none'),
};

export const DEFAULT_PANEL_WIDTH = '400px';
